import { ReactNode } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { isBagelAdmin } from '../utils';
import { Box, Text, Button } from '@mantine/core';

interface AdminProtectedRouteProps {
  children: ReactNode;
}

export const AdminProtectedRoute = ({ children }: AdminProtectedRouteProps) => {
  const auth0 = useAuth0();
  const user = auth0.user;
  const role = user ? user['bagel/role'] : '';
  
  // Check if user is admin
  const isAdmin = role === "admin";
  
  if (!isAdmin) {
    return (
      <Box p="xl" ta="center">
        <Text size="xl" fw={600} mb="md">Access Denied</Text>
        <Text color="dimmed" mb="lg">
          You don't have permission to access this page. Only administrators can view settings.
        </Text>
        <Button onClick={() => window.history.back()}>
          Go Back
        </Button>
      </Box>
    );
  }
  
  return <>{children}</>;
}; 